(function () {
  'use strict';

  function uploadUrl(value) {
    try {
      const url = new URL(String(value || ''), 'https://ronron.site');
      if (url.protocol !== 'https:' || url.username || url.password || url.port) return '';
      const trusted = url.hostname === 'option.nyc3.digitaloceanspaces.com' ||
        (url.hostname === 'cdn.shopify.com' && url.pathname.includes('/uploads/')) ||
        (url.hostname === 'ronron.site' && url.pathname.startsWith('/uploads/'));
      return trusted ? url.href : '';
    } catch (_) { return ''; }
  }

  function photoUrl(value) {
    const url = uploadUrl(value);
    return url && /\.(?:avif|png|jpe?g|webp|gif)$/i.test(new URL(url).pathname) ? url : '';
  }

  function propertyName(name) {
    const match = String(name || '').match(/^properties\[([^\]]+)\]$/);
    return match && !match[1].startsWith('_') ? match[1] : '';
  }

  function uploadProblem(required, pending, urls) {
    if (pending) return '写真のアップロード完了までお待ちください。';
    return required && !urls.length ? '写真を添付してください。' : '';
  }

  if (typeof module !== 'undefined' && module.exports) module.exports = {photoUrl, uploadUrl, propertyName, uploadProblem};
  if (typeof document === 'undefined' || window.ronronPurchaseReviewLoaded) return;
  window.ronronPurchaseReviewLoaded = true;

  const controllers = new WeakMap();
  const approved = new WeakMap();
  const localPhotos = new WeakMap();
  const uploads = new WeakMap();
  const ownedObjectUrls = new Set();
  const visible = (element) => !element.disabled && !!(element.closest('.gpo-form__group') || element).getClientRects().length;
  const controlsFor = (form) => Array.from(form.elements).filter(element => element.matches('input,select,textarea'));
  const appsFor = form => [...new Set([
    ...form.querySelectorAll('.gpo-app'),
    ...controlsFor(form).map(input => input.closest('.gpo-app')).filter(Boolean)
  ])];

  function staleProperty(form, input) {
    if (input.type !== 'hidden' || !propertyName(input.name) || !input.hasAttribute('data-field-name') || !appsFor(form).length) return false;
    const field = input.getAttribute('data-field-name');
    const sources = controlsFor(form).filter(element => element.type !== 'hidden' && (
      element.getAttribute('data-field-name') === field || propertyName(element.getAttribute('data-name') || element.name) === field
    ));
    return !sources.some(visible);
  }

  function uploadedUrls(form, input) {
    const field = input.getAttribute('data-field-name') || propertyName(input.name);
    const elements = controlsFor(form).filter(element => element.type !== 'file' && (
      element.getAttribute('data-field-name') === field || propertyName(element.name) === field ||
      (field && propertyName(element.name).startsWith(field + '_'))
    ));
    return [...new Set(elements.filter(element => !element.disabled).flatMap(element => {
      try {
        const values = JSON.parse(element.value);
        return Array.isArray(values) ? values.map(uploadUrl).filter(Boolean) : [uploadUrl(element.value)].filter(Boolean);
      } catch (_) { return [uploadUrl(element.value)].filter(Boolean); }
    }))];
  }

  function uploadKey(input) {
    return input.getAttribute('data-field-name') || propertyName(input.getAttribute('data-name') || input.name) || input.name;
  }

  function uploadPending(form, input, group) {
    const state = uploads.get(form)?.get(uploadKey(input));
    return (state ? state.pending : !!input.files?.length) || !!group.querySelector('.gpo-uploading,[data-gpo-image-editor-loading]');
  }

  function snapshot(form) {
    const rows = [];
    const errors = [];
    const seen = new Set();
    const add = (name, value, photos, target) => {
      if (!name || name.startsWith('_') || (!value && !photos.length)) return;
      const key = name + '\u0000' + value + '\u0000' + photos.join('\u0000');
      if (seen.has(key)) return;
      seen.add(key);
      rows.push({name, value, photos, target});
    };
    for (const input of controlsFor(form)) {
      if (!visible(input) || input.type === 'hidden' || ['submit','button'].includes(input.type)) continue;
      if (['radio','checkbox'].includes(input.type) && !input.checked) continue;
      const rawName = input.getAttribute('data-name') || input.name;
      const name = propertyName(rawName) || input.name.match(/^options\[(.+)\]$/)?.[1] || (input.closest('.gpo-app,variant-radios,variant-selects') ? input.name : input.name === 'quantity' ? '数量' : '');
      if (!name || name === 'id') continue;
      if (input.type === 'file') {
        const group = input.closest('.gpo-form__group') || input.parentElement;
        const isAppUpload = input.hasAttribute('data-type');
        const urls = uploadedUrls(form, input);
        if (!isAppUpload) {
          for (const file of input.files || []) {
            if (!localPhotos.has(file)) {
              const url = URL.createObjectURL(file);
              localPhotos.set(file, url);
              ownedObjectUrls.add(url);
            }
            urls.push(localPhotos.get(file));
          }
        }
        const pending = isAppUpload && uploadPending(form, input, group);
        const required = input.required || input.hasAttribute('presence') || input.getAttribute('aria-required') === 'true';
        const problem = uploadProblem(required, pending, urls);
        if (problem) errors.push({input, message:name + '：' + problem});
        add(name, urls.length ? urls.length + '枚' : '', urls, input);
      } else {
        const value = input.tagName === 'SELECT' ? Array.from(input.selectedOptions).filter(option => option.value).map(option => option.textContent.trim()).join('、') : input.value;
        const required = input.required || input.hasAttribute('presence') || input.getAttribute('aria-required') === 'true';
        if (required && !String(value || '').trim()) errors.push({input, message:name + '：入力・選択してください。'});
        add(name, value, [], input);
      }
    }
    // Persisted public properties also cover app fields rendered outside the product form.
    for (const input of controlsFor(form)) {
      if (input.disabled || input.type !== 'hidden' || staleProperty(form, input)) continue;
      const name = propertyName(input.name);
      if (!name || rows.some(row => row.name === name)) continue;
      const field = input.getAttribute('data-field-name') || name;
      const source = controlsFor(form).find(element => element.type !== 'hidden' && (
        element.getAttribute('data-field-name') === field || propertyName(element.getAttribute('data-name') || element.name) === field
      ));
      if (source && !visible(source)) continue;
      // Globo's orphaned hidden values can survive removal of conditional controls.
      if (!source && input.hasAttribute('data-field-name') && appsFor(form).length) continue;
      const url = uploadUrl(input.value);
      if (url && rows.some(row => row.photos.includes(url))) continue;
      add(name, url ? '1枚' : input.value, url ? [url] : [], input);
    }
    return {rows, errors};
  }

  function textElement(tag, text, className) {
    const element = document.createElement(tag);
    element.textContent = text;
    if (className) element.className = className;
    return element;
  }

  function controllerFor(form) {
    if (!(form instanceof HTMLFormElement)) return null;
    const id = form.getAttribute('id');
    const root = Array.from(document.querySelectorAll('[data-ronron-purchase-review]')).find(element => element.dataset.formId === id);
    if (!root) return null;
    if (controllers.has(root)) return controllers.get(root);
    form.addEventListener('formdata', event => {
      for (const input of controlsFor(form)) {
        if (staleProperty(form, input)) event.formData.delete(input.name);
      }
    });

    const dialog = document.createElement('dialog');
    dialog.className = 'ronron-review-dialog';
    dialog.setAttribute('aria-labelledby', root.dataset.dialogId + '-heading');
    const heading = textElement('h2', 'ご注文内容の確認');
    heading.id = root.dataset.dialogId + '-heading';
    const product = textElement('p', root.dataset.productTitle, 'ronron-review-product');
    const list = document.createElement('dl');
    list.className = 'ronron-review-options';
    const message = textElement('p', '', 'ronron-review-message');
    message.setAttribute('role', 'alert');
    const actions = document.createElement('div');
    actions.className = 'ronron-review-actions';
    const back = textElement('button', '入力内容を修正', 'button button--secondary');
    const confirm = textElement('button', '内容を確認してカートに追加', 'button');
    back.type = confirm.type = 'button';
    actions.append(back, confirm);
    dialog.append(heading, product, list, message, actions);
    document.body.append(dialog);
    let submitter;
    let currentForm;
    let fingerprint;
    let priorFocus;
    const keyOf = state => JSON.stringify(state.rows.map(({name,value,photos}) => ({name,value,photos})));

    function report(state) {
      const target = state.errors[0];
      const alert = root.querySelector('[role=alert]');
      alert.textContent = state.errors.map(error => error.message).join('\n');
      if (target) {
        target.input.closest('.gpo-form__group')?.scrollIntoView({block:'center',behavior:'smooth'});
        target.input.focus({preventScroll:true});
      }
      return !target;
    }

    function close() {
      dialog.close();
      priorFocus?.focus({preventScroll:true});
    }

    back.addEventListener('click', close);
    dialog.addEventListener('cancel', () => priorFocus?.focus({preventScroll:true}));
    confirm.addEventListener('click', () => {
      if (!currentForm?.isConnected || (submitter && !submitter.isConnected)) { close(); return; }
      if (submitter && (submitter.disabled || submitter.getAttribute('aria-disabled') === 'true')) {
        message.textContent = '商品情報を更新中です。入力画面に戻り、更新後にもう一度ご確認ください。';
        return;
      }
      if (!currentForm.reportValidity()) { close(); return; }
      const state = snapshot(currentForm);
      if (!report(state)) { close(); return; }
      if (keyOf(state) !== fingerprint) {
        message.textContent = '選択内容が変更されました。もう一度内容をご確認ください。';
        render(state);
        return;
      }
      close();
      const approvedForm = currentForm;
      approved.set(approvedForm, {click:false, submit:false, expires:Date.now() + 10000});
      const excluded = controlsFor(approvedForm).filter(input => !input.disabled && staleProperty(approvedForm, input));
      for (const input of excluded) input.disabled = true;
      approvedForm.setAttribute('data-ronron-review-approved', '');
      confirm.disabled = true;
      try {
        if (submitter) submitter.click();
        else approvedForm.requestSubmit();
      } finally {
        // GPO snapshots its JSON payload during the click; do not retain app-owned disabled state.
        queueMicrotask(() => { for (const input of excluded) input.disabled = false; });
      }
    });

    function render(state) {
      list.replaceChildren();
      for (const row of state.rows) {
        const wrapper = document.createElement('div');
        const value = textElement('dd', row.value);
        if (row.photos.length) {
          const photos = document.createElement('div');
          photos.className = 'ronron-review-photos';
          for (const [index, url] of row.photos.entries()) {
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.rel = 'noopener noreferrer';
            if (url.startsWith('blob:') || photoUrl(url)) {
              const image = document.createElement('img');
              image.src = url;
              image.alt = row.name + ' ' + (index + 1);
              image.width = image.height = 96;
              link.append(image);
            } else {
              link.textContent = '添付ファイル ' + (index + 1) + ' を開く';
            }
            photos.append(link);
          }
          value.append(photos);
        }
        const label = row.photos.length ? row.name.replace(/^file-(\d+)$/, '添付写真 $1') : row.name;
        wrapper.append(textElement('dt', label), value);
        list.append(wrapper);
      }
      fingerprint = keyOf(state);
    }

    const controller = {open(form, button) {
      approved.delete(form);
      form.removeAttribute('data-ronron-review-approved');
      if (window.GPOConfigs?.productOptionSetMap?.[root.dataset.productId] && !controlsFor(form).some(input => input.hasAttribute('data-type') && input.closest('.gpo-app[data-option-set-id]'))) {
        root.querySelector('[role=alert]').textContent = '選択項目を読み込んでいます。表示後にもう一度お試しください。';
        return;
      }
      const state = snapshot(form);
      if (!report(state)) return;
      if (!form.reportValidity()) return;
      currentForm = form;
      submitter = button;
      priorFocus = document.activeElement;
      message.textContent = '';
      confirm.disabled = false;
      render(state);
      if (!dialog.open) dialog.showModal();
      back.focus();
    }};
    controllers.set(root, controller);
    return controller;
  }

  function intercept(event, form, button) {
    const controller = controllerFor(form);
    if (!controller) return;
    const handoff = approved.get(form);
    if (handoff && (!event.isTrusted || event.type === 'submit') && Date.now() < handoff.expires && !handoff[event.type]) {
      handoff[event.type] = true;
      if (event.type === 'click') queueMicrotask(() => {
        // A vendor-owned click already submits directly; do not leave a second submit permit.
        if (event.defaultPrevented) handoff.submit = true;
      });
      return;
    }
    if (button?.disabled || button?.getAttribute('aria-disabled') === 'true') return;
    event.preventDefault();
    event.stopImmediatePropagation();
    controller.open(form, button || form.querySelector('[type=submit]'));
  }

  window.ronronPurchaseReviewCapture = event => {
    if (event.type === 'submit') return intercept(event, event.target, event.submitter);
    const button = event.target.closest?.('button[type=submit],button[name=add],input[type=submit]');
    if (button) intercept(event, button.form, button);
  };
  if (!window.ronronPurchaseReviewCaptureInstalled) {
    window.ronronPurchaseReviewCaptureInstalled = true;
    for (const type of ['click','submit']) window.addEventListener(type, window.ronronPurchaseReviewCapture, true);
  }
  function trackUpload(event) {
    const input = event.target;
    if (!input.matches?.('input[type=file][data-type]') || !input.form || !(input.files?.length || event.dataTransfer?.files?.length) || !controllerFor(input.form)) return;
    if (!uploads.has(input.form)) uploads.set(input.form, new Map());
    uploads.get(input.form).set(uploadKey(input), {pending:true});
  }
  window.addEventListener('change', trackUpload, true);
  window.addEventListener('drop', trackUpload, true);
  window.addEventListener('gpoFileSettled', event => {
    const input = event.target;
    const state = input.form && uploads.get(input.form)?.get(uploadKey(input));
    if (state) state.pending = false;
  }, true);
  window.addEventListener('pagehide', () => {
    for (const url of ownedObjectUrls) URL.revokeObjectURL(url);
    ownedObjectUrls.clear();
  });

  function installGuards() {
    for (const root of document.querySelectorAll('[data-ronron-purchase-review]')) {
      if (root.dataset.guardInstalled) continue;
      root.dataset.guardInstalled = 'true';
      let queued = false;
      const refresh = () => {
        if (queued) return;
        queued = true;
        requestAnimationFrame(() => {
          queued = false;
          const form = document.getElementById(root.dataset.formId);
          if (!(form instanceof HTMLFormElement)) return;
          const required = controlsFor(form).some(input => input.type === 'file' && visible(input) && (input.required || input.hasAttribute('presence') || input.getAttribute('aria-required') === 'true'));
          form.toggleAttribute('data-ronron-photo-required', required);
        });
      };
      new MutationObserver(refresh).observe(document.body, {
        childList:true,subtree:true,attributes:true,attributeFilter:['disabled','presence','required','style','class']
      });
      refresh();
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installGuards);
  else installGuards();
  document.addEventListener('shopify:section:load', installGuards);
})();
